import api from './api';

const customerService = {
  // Get all customers with optional filters
  getCustomers: (params = {}) => {
    return api.get('/api/users', { params });
  },

  // Get single customer by ID
  getCustomer: (id) => {
    return api.get(`/api/users/${id}`);
  },

  // Get customer's orders - uses /customers path
  getCustomerOrders: (id, params = {}) => {
    return api.get(`/api/customers/${id}/orders`, { params });
  },

  // Update customer
  updateCustomer: (id, data) => {
    return api.put(`/api/users/${id}`, data);
  },

  // Update customer status - uses PATCH instead of PUT
  updateCustomerStatus: (id, status) => {
    return api.patch(`/api/users/${id}/status`, { status });
  },

  // Add note to customer - uses /customers path
  addNote: (id, note) => {
    return api.post(`/api/customers/${id}/notes`, { note });
  },

  // Update tags - not implemented yet in backend
  updateTags: (id, tags) => {
    return api.put(`/api/users/${id}/tags`, { tags });
  },

  // Get customer stats - extra endpoint
  getCustomerStats: (id) => {
    return api.get(`/api/customers/${id}/stats`);
  },
};

export default customerService;
